/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Ocop_StarsInputs */

const vi_shop_ocop_stars = /** @type {(inputs: Shop_Ocop_StarsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số sao`)
};

/**

* @param {Shop_Ocop_StarsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_ocop_stars = /** @type {((inputs?: Shop_Ocop_StarsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Ocop_StarsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_ocop_stars(inputs)
});